<template>
  <div id="v-admin-panel-image-drive">
    <br>
    <gallery :collective="collective"></gallery>
  </div>
</template>
<script>
import Gallery from '../../Components/Gallery'

export default {
  props: ['collective'],
  components: { Gallery }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/General/AdminImageDrive.vue